import firebase from 'firebase';

const config = {
    apiKey: "AIzaSyC569kmRM1UhUHBEDP2ZqDIMDEfWR81SYY",
    authDomain: "crowdsale-69e61.firebaseapp.com",
    databaseURL: "https://crowdsale-69e61.firebaseio.com",
    projectId: "crowdsale-69e61",
    storageBucket: "crowdsale-69e61.appspot.com",
    messagingSenderId: "69512879248"
};
firebase.initializeApp(config);
